var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgMicrosoftOutlook = function SvgMicrosoftOutlook(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 7.05H20.3399C20.7044 7.05 21 7.34565 21 7.71015V16.2899C21 16.6544 20.7044 16.95 20.3399 16.95H13.8V7.05Z",
    fill: "#1976D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1 9.28066H13.8V16.2746H20.1V9.28066Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.35 21L3 18.975V5.025L13.35 3V21Z",
    fill: "#1976D2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06333 8.625C6.63413 8.625 5.47583 10.1361 5.47583 12C5.47583 13.8639 6.63413 15.375 8.06333 15.375C9.49253 15.375 10.6508 13.8639 10.6508 12C10.6508 10.1361 9.49253 8.625 8.06333 8.625ZM7.95083 14.025C7.20518 14.025 6.60083 13.1182 6.60083 12C6.60083 10.8817 7.20518 9.975 7.95083 9.975C8.69648 9.975 9.30083 10.8817 9.30083 12C9.30083 13.1182 8.69648 14.025 7.95083 14.025Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.036 14.5809H13.821V15.8859H15.036V14.5809Z",
    fill: "#1976D2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5663 14.5809H15.3513V15.8859H16.5663V14.5809Z",
    fill: "#1976D2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0982 14.5809H16.8832V15.8859H18.0982V14.5809Z",
    fill: "#1976D2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.036 12.9712H13.821V14.2762H15.036V12.9712Z",
    fill: "#1976D2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5663 12.9712H15.3513V14.2762H16.5663V12.9712Z",
    fill: "#1976D2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0982 12.9712H16.8832V14.2762H18.0982V12.9712Z",
    fill: "#1976D2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6283 12.9712H18.4133V14.2762H19.6283V12.9712Z",
    fill: "#1976D2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.036 11.4182H13.821V12.7232H15.036V11.4182Z",
    fill: "#1976D2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5663 11.4182H15.3513V12.7232H16.5663V11.4182Z",
    fill: "#1976D2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0982 11.4182H16.8832V12.7232H18.0982V11.4182Z",
    fill: "#1976D2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6283 11.4182H18.4133V12.7232H19.6283V11.4182Z",
    fill: "#1976D2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5663 9.8001H15.3513V11.1051H16.5663V9.8001Z",
    fill: "#1976D2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0982 9.8001H16.8832V11.1051H18.0982V9.8001Z",
    fill: "#1976D2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6283 9.8001H18.4133V11.1051H19.6283V9.8001Z",
    fill: "#1976D2"
  })));
};
export default SvgMicrosoftOutlook;